import { render } from "./infoNotas.vue?vue&type=template&id=7ed7052a&scoped=true"
import script from "./infoNotas.vue?vue&type=script&lang=js"
export * from "./infoNotas.vue?vue&type=script&lang=js"

import "./infoNotas.vue?vue&type=style&index=0&id=7ed7052a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed7052a"]])

export default __exports__